import { LoadCancelledSurgicalScheduleRequest } from 'domain/usecases/cancelled-surgical-schedule-request/load-cancelled-surgical-schedule-request'
import { SurgicalScheduleRepository } from 'repository/interfaces/surgical-schedule-repository'

export class RemoteLoadCancelledSurgicalScheduleRequest
  implements LoadCancelledSurgicalScheduleRequest
{
  constructor(
    private readonly scheduleRepository: SurgicalScheduleRepository
  ) {}

  async load(
    params: LoadCancelledSurgicalScheduleRequest.Params
  ): Promise<LoadCancelledSurgicalScheduleRequest.Model> {
    return this.scheduleRepository.loadCancelledSurgicalScheduleRequest(params)
  }
}

export type LoadCancelledSurgicalScheduleRequestModel =
  LoadCancelledSurgicalScheduleRequest.Model
